import React from 'react'
import Create from '../components/Create/Create'

function CreatePage() {
    return (
        <div>
            <Create />
        </div>
    )
}

export default CreatePage
